import { Component } from '@angular/core';

@Component({
  selector: 'upsc-quick-insights',
  templateUrl: './quick-insights.component.html',
  styleUrls: ['./quick-insights.component.scss']
})
export class QuickInsightsComponent {

}
